import React from 'react';
import { Checkbox, ListItemText, MenuItem } from '@mui/material';

import { Select } from '@occc-app/design-system';

type SurveyAnswersSelectProps = {
  name: string;
  options: { uuid: string; label: string }[];
  selectedUuids: string[];
};

export const SurveyAnswersSelect = ({ name, options, selectedUuids }: SurveyAnswersSelectProps) => {
  const renderValue = React.useCallback(
    (selectedUuids: string[]) => {
      return options
        .filter((option) => selectedUuids.includes(option.uuid))
        .map((option) => option.label)
        .join(', ');
    },
    [options],
  );

  return (
    <Select multiple name={name} renderValue={renderValue}>
      {options.map((option) => (
        <MenuItem key={option.uuid} value={option.uuid} sx={{ p: 1 }}>
          <Checkbox checked={selectedUuids.includes(option.uuid)} />
          <ListItemText primary={option.label} />
        </MenuItem>
      ))}
    </Select>
  );
};
